import { render } from "./RatingStats.vue?vue&type=template&id=26a704eb&scoped=true&ts=true"
import script from "./RatingStats.vue?vue&type=script&lang=ts"
export * from "./RatingStats.vue?vue&type=script&lang=ts"

import "./RatingStats.vue?vue&type=style&index=0&id=26a704eb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26a704eb"]])

export default __exports__